(function () {
  const timestampTagPrefix = 'ww_signup_v1__';
  const knownInterests = [
    'interest_all',
    'interest_welsh_content',
    'interest_welsh_lessons',
    'interest_english_lessons',
    'interest_course',
    'interest_dragon_club',
  ];

  function normaliseToken(value, fallback) {
    const token = String(value || '')
      .toLowerCase()
      .replace(/[^a-z0-9_]+/g, '_')
      .replace(/^_+|_+$/g, '');

    return token || fallback;
  }

  function selectedInterest(tags) {
    const selected = String(tags || '')
      .split(',')
      .map((tag) => tag.trim())
      .find((tag) => knownInterests.includes(tag));

    return selected || 'newsletter_general';
  }

  function compactUtcTimestamp(date) {
    return date.toISOString().replace(/[-:]/g, '').replace(/\.\d{3}Z$/, 'Z');
  }

  async function shopifyServerTimestamp() {
    const controller = new AbortController();
    const timeout = window.setTimeout(() => controller.abort(), 4500);

    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}cart.js?ww_signup_clock=${Date.now()}`, {
        cache: 'no-store',
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
        signal: controller.signal,
      });
      const serverDate = response.headers.get('date');
      const serverTime = serverDate ? new Date(serverDate) : null;

      if (
        !response.ok ||
        !serverTime ||
        Number.isNaN(serverTime.getTime()) ||
        Math.abs(serverTime.getTime() - Date.now()) > 10 * 60 * 1000
      ) {
        return 'UNKNOWN';
      }

      return compactUtcTimestamp(serverTime);
    } catch (_error) {
      return 'UNKNOWN';
    } finally {
      window.clearTimeout(timeout);
    }
  }

  function setSubmittedTags(form, field, tags) {
    if (field.tagName === 'SELECT') {
      field.removeAttribute('name');
      const hiddenField = document.createElement('input');
      hiddenField.type = 'hidden';
      hiddenField.name = 'contact[tags]';
      hiddenField.value = tags;
      hiddenField.dataset.wwSignupTimestamp = 'true';
      form.appendChild(hiddenField);
      return;
    }

    field.value = tags;
    field.dataset.wwSignupTimestamp = 'true';
  }

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest?.('form[data-newsletter-form]');
    if (!form) return;
    if (form.dataset.wwSignupStamped === 'true') return;

    event.preventDefault();
    if (form.dataset.wwSignupStamping === 'true') return;
    form.dataset.wwSignupStamping = 'true';

    const submitter = event.submitter || form.querySelector('[type="submit"]');
    const controls = Array.from(form.querySelectorAll('[type="submit"]'));
    const previousDisabledStates = controls.map((control) => control.disabled);
    controls.forEach((control) => {
      control.disabled = true;
    });

    try {
      const tagField = form.querySelector('[name="contact[tags]"]');
      if (!tagField) throw new Error('Newsletter tag field missing');

      const originalTags = tagField.value;
      const interest = selectedInterest(originalTags);
      const source = normaliseToken(form.dataset.signupSource, 'unknown_source');
      const timestamp = await shopifyServerTimestamp();
      const timestampTag = `${timestampTagPrefix}${interest}__${timestamp}__${source}`;
      const submittedTags = String(originalTags)
        .split(',')
        .map((tag) => tag.trim())
        .filter(Boolean);

      if (!submittedTags.includes(timestampTag)) submittedTags.push(timestampTag);
      setSubmittedTags(form, tagField, submittedTags.join(','));
    } catch (_error) {
      const tagField = form.querySelector('[name="contact[tags]"]');
      if (tagField) {
        const originalTags = tagField.value;
        const interest = selectedInterest(originalTags);
        const source = normaliseToken(form.dataset.signupSource, 'unknown_source');
        setSubmittedTags(
          form,
          tagField,
          `${originalTags},${timestampTagPrefix}${interest}__UNKNOWN__${source}`
        );
      }
    } finally {
      form.dataset.wwSignupStamped = 'true';
      delete form.dataset.wwSignupStamping;
      controls.forEach((control, index) => {
        control.disabled = previousDisabledStates[index];
      });
      if (submitter) {
        form.requestSubmit(submitter);
      } else {
        form.requestSubmit();
      }
    }
  });
})();
